// dependencies
import { useState } from "react"
import { useNavigate } from "react-router"
import { signInWithEmailAndPassword } from "firebase/auth"
import { toast } from "react-toastify"

// style
import styles from "./css/Login.module.css"

// components
import { auth } from "../../api/firebase/firebaseConfig"


const Login = () => {
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    let navigate = useNavigate()

    // handle login
    const handleLogin = async () => {
        try {
            await signInWithEmailAndPassword(auth, email, password)
            // change to user dashboard
            navigate("/profile")
        } catch (err) {
            toast(err.code, { type: "error" })
        }
    }

    return (
        <div className={styles.container}>
            <div className={styles.loginBox}>
                <h2 className={styles.title}>Admin Login</h2>

                <label className={styles.label}>Email</label>
                <input
                    type="email"
                    className={styles.input}
                    placeholder="Enter Email"
                    onChange={(e) => setEmail(e.target.value)}
                />

                <label className={styles.label}>Password</label>
                <input
                    type="password"
                    className={styles.input}
                    placeholder="Enter Password"
                    onChange={(e) => setPassword(e.target.value)}
                />

                <button className={styles.loginButton} onClick={handleLogin}>
                    Login
                </button>
            </div>
        </div>
    );
}

export default Login
